<div class="info-box-wrapper" *ngIf="order">
	<div class="pedido-wrapper" [ngClass]="openCode ? '' : 'full'">
		<img src="" class="brand-logo" alt="">
        <div class="main-box">
            <div class="number-box">
                <div class="box-container">
                	<span class="number-container">{{box_name}}</span>
                </div>
            </div>
            <p class="nombre-cliente truncate" [innerHTML]="order.client.nickname"></p>
            <div class="pedido">
                <div class="pedido-text title" *ngIf="openCode">Abrí el SmartBox con tu RUT.</div>
                <div class="pedido-text title" *ngIf="!openCode">Abrí el SmartBox con tu celular.</div>
                <!-- <div class="pedido-text">Tenés tiempo hasta las <span class="time">15:45</span> para retirarlo.</div> -->
            </div>            
        </div>
        <div class="stamp-wrapper">
        	<!-- <div class="stamp-item">
        		<div class="icon-wrapper bg-success">
        			<i class="material-icons">verified_user</i>
        		</div>		
        		<div class="stamp-text">Producto Sanitizado</div>
        	</div>
        	<div class="stamp-item" *ngIf="openCode">
        		<div class="icon-wrapper bg-info">
        			<i class="material-icons">invert_colors</i>
        		</div>		
        		<div class="stamp-text">Pantalla Sanitizada</div>
        	</div> -->
        </div>	        
	</div>
	<div class="id-sign-wrapper">
		<div class="invalid-code" [ngClass]="errorCode ? 'active' : ''">Código inválido</div>
		<div class="arrow-down">
			<i class="material-icons">arrow_downward</i>
		</div>
		<div class="id-text-wrapper">
			<p class="id-text">Ingresa tu RUT para <br> abrir el SmartBox</p>
		</div>
		<div class="form-group">
			<input class="id-number" [ngClass]="errorCode ? 'animate__animated animate__shakeX animate__fast' : ''" [(ngModel)]="inputCode" />
			<a class="btn-backspace"  (panstart)="delNumber()" (tap)="delNumber()" (press)="delNumber()"><i class="material-icons backspace">backspace</i></a>
		</div>
		<div class="keyboard">
			<div class="keyboard-btn" (panstart)="setNumber(1)" (tap)="setNumber(1)" (press)="setNumber(1)">1</div>
			<div class="keyboard-btn" (panstart)="setNumber(2)" (tap)="setNumber(2)" (press)="setNumber(2)">2</div>
			<div class="keyboard-btn" (panstart)="setNumber(3)" (tap)="setNumber(3)" (press)="setNumber(3)">3</div>
			<div class="keyboard-btn" (panstart)="setNumber(4)" (tap)="setNumber(4)" (press)="setNumber(4)">4</div>
			<div class="keyboard-btn" (panstart)="setNumber(5)" (tap)="setNumber(5)" (press)="setNumber(5)">5</div>
			<div class="keyboard-btn" (panstart)="setNumber(6)" (tap)="setNumber(6)" (press)="setNumber(6)">6</div>
			<div class="keyboard-btn" (panstart)="setNumber(7)" (tap)="setNumber(7)" (press)="setNumber(7)">7</div>
			<div class="keyboard-btn" (panstart)="setNumber(8)" (tap)="setNumber(8)" (press)="setNumber(8)">8</div>
			<div class="keyboard-btn" (panstart)="setNumber(9)" (tap)="setNumber(9)" (press)="setNumber(9)">9</div>
			<div class="keyboard-btn" (panstart)="setNumber('k')" (tap)="setNumber('k')" (press)="setNumber('k')">K</div>
			<div class="keyboard-btn" (panstart)="setNumber(0)" (tap)="setNumber(0)" (press)="setNumber(0)">0</div>
			<div class="keyboard-btn check" [ngClass]="validCode() ? '' : 'disabled'" (click)="checkCode()"><i class="material-icons">check</i></div>
		</div>
	</div>
</div>